import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel, RelatedProductModel } from "../models/product";
import cart from "../services/Cart";
import GoogleEnhancedEcommerce from "../services/GoogleEnhancedEcommerce";

@Component
export default class RelatedProductList extends Vue {
    private readonly googleAnalyticsDimensionIdentifier: string;
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
        this.googleAnalyticsDimensionIdentifier = "ProductPage";
    }

    get variant(): Variant {
        return productStore.variant;
    }

    get relatedProducts(): RelatedProductModel[] {
        return this.variant.relatedProducts;
    }

    get quantity(): number {
        return productStore.quantity;
    }

    set quantity(value: number) {
        productStore.dispatchQuantity(value);
    }

    get buyButtonDisabled(): boolean {
        return this.quantity < 1;
    }

    get palletRequired(): number {
        return productStore.palletRequired;
    }

    set palletRequired(value: number) {
        productStore.dispatchPalletRequired(value);
    }

    protected addToCart(relatedProduct: RelatedProductModel) {
        if (this.buyButtonDisabled) {
            return;
        }

        cart.addToCart({
            quantity: relatedProduct.quantity,
            variantId: relatedProduct.id,
            variantSystemId: relatedProduct.systemId
        });

        this.ReportAddToCartToGoogleEnhancedEcommerce(relatedProduct);
    }

    private ReportAddToCartToGoogleEnhancedEcommerce(relatedProduct: RelatedProductModel) {
        const gee = new GoogleEnhancedEcommerce();
        gee.PushAddToCartToGoogle(
            relatedProduct.name,
            relatedProduct.id,
            relatedProduct.priceValue,
            "",
            relatedProduct.quantity,
            this.googleAnalyticsDimensionIdentifier,
            relatedProduct.currencyCode,
            window.site.settings.webShopActivated ? true : false,
        );
    }
}
